require('./runtime');
(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("./utils"), require("./button"), require("./flyout"));
	else if(typeof define === 'function' && define.amd)
		define(["./utils", "./button", "./flyout"], factory);
	else {
		var a = typeof exports === 'object' ? factory(require("./utils"), require("./button"), require("./flyout")) : factory(root["./utils"], root["./button"], root["./flyout"]);
		for(var i in a) (typeof exports === 'object' ? exports : root)[i] = a[i];
	}
})(window, function(__WEBPACK_EXTERNAL_MODULE__4__, __WEBPACK_EXTERNAL_MODULE__15__, __WEBPACK_EXTERNAL_MODULE__28__) {
return (window["wpBaUiCarbonToolkit"] = window["wpBaUiCarbonToolkit"] || []).push([[12],{

/***/ 0:
/***/ (function(module, exports) {

module.exports = require("@babel/runtime/helpers/interopRequireDefault");

/***/ }),

/***/ 1:
/***/ (function(module, exports) {

module.exports = require("react");

/***/ }),

/***/ 10:
/***/ (function(module, exports) {

module.exports = require("style-loader/lib/addStyles");

/***/ }),

/***/ 11:
/***/ (function(module, exports) {

module.exports = require("@babel/runtime/helpers/assertThisInitialized");

/***/ }),

/***/ 15:
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE__15__;

/***/ }),

/***/ 185:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(186);


/***/ }),

/***/ 186:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(0);

exports.__esModule = true;

var _ColorPicker = _interopRequireDefault(__webpack_require__(187));

exports["default"] = _ColorPicker["default"];
exports.ColorPicker = _ColorPicker["default"];

/***/ }),

/***/ 187:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireWildcard = __webpack_require__(2);

var _interopRequireDefault = __webpack_require__(0);

exports.__esModule = true;
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(7));

var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(8));

var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(11));

var _inheritsLoose2 = _interopRequireDefault(__webpack_require__(5));

var _defineProperty2 = _interopRequireDefault(__webpack_require__(6));

var _react = _interopRequireWildcard(__webpack_require__(1));

var _propTypes = _interopRequireDefault(__webpack_require__(3));

var _textColor_ = _interopRequireDefault(__webpack_require__(188));

var _utils = __webpack_require__(4);

var _flyout = __webpack_require__(28);

var _button = _interopRequireDefault(__webpack_require__(15));

var _ColorPicker = _interopRequireDefault(__webpack_require__(189));

var _StringResource = _interopRequireDefault(__webpack_require__(191));

/* IBM Confidential
 *
 * OCO Source Materials
 *
 * IBM Cognos Products: ba-ui-carbon-toolkit
 * (C) Copyright IBM Corp. 2019, 2021
 *
 * The source code for this program is not published or otherwise
 * divested of its trade secrets, irrespective of what has been
 * deposited with the U.S. Copyright Office.
 * NLS_ENCODING=UTF-8
 * NLS_MESSAGEFORMAT_NONE
 */
var DEFAULT_OFFSET = 2;

var colorpickerClassName = _ColorPicker["default"].colorpickerClassName.replace(/"/g, '');

var sanitize = _utils.propsUtils.sanitize;
var uniqueId = _utils.lodash.uniqueId;
var BOTTOM_RIGHT_START = _flyout.FlyoutPosition.BOTTOM_RIGHT_START,
    BOTTOM_LEFT_START = _flyout.FlyoutPosition.BOTTOM_LEFT_START;

var ColorPicker = /*#__PURE__*/function (_Component) {
  (0, _inheritsLoose2["default"])(ColorPicker, _Component);

  function ColorPicker(props) {
    var _this;

    _this = _Component.call(this, props) || this;
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_displayColor", function (color, index) {
      return /*#__PURE__*/_react["default"].createElement("div", {
        key: index,
        tabIndex: "0" // Make it keyboard focusable
        ,
        style: {
          background: color
        },
        className: colorpickerClassName + "__cell",
        onClick: function onClick() {
          return _this._handleSelect(color);
        },
        onKeyDown: function onKeyDown(e) {
          return _this._handleKey(e, color);
        }
      });
    });
    _this.state = {
      open: false
    };
    _this._handleOpen = _this._handleOpen.bind((0, _assertThisInitialized2["default"])(_this));
    _this._handleSelect = _this._handleSelect.bind((0, _assertThisInitialized2["default"])(_this));
    _this._handleKey = _this._handleKey.bind((0, _assertThisInitialized2["default"])(_this));
    _this._id = uniqueId('ba-common-color-picker__');
    _this.buttonRef = _react["default"].createRef();
    return _this;
  }

  var _proto = ColorPicker.prototype;

  _proto._handleOpen = function _handleOpen() {
    this.setState(function (state) {
      return {
        open: !state.open
      };
    });
  };

  _proto._handleSelect = function _handleSelect(color) {
    this.props.onColorSelected(color); // close the flyout after selection

    this.setState(function (state) {
      return {
        open: !state.open
      };
    });
  };

  _proto._handleKey = function _handleKey(e, color) {
    // 13 = Return, 32 = Space
    if (e.keyCode === 13 || e.keyCode === 32) {
      this._handleSelect(color); // Prevent browser's default action: space does a PageDown


      e.preventDefault();
    }
  };

  _proto.render = function render() {
    var _this2 = this;

    var open = this.state.open;
    var _this$props = this.props,
        selectedColor = _this$props.selectedColor,
        disabled = _this$props.disabled,
        title = _this$props.title,
        className = _this$props.className,
        style = _this$props.style,
        buttonExtraOptions = _this$props.buttonExtraOptions,
        flyoutExtraOptions = _this$props.flyoutExtraOptions,
        colorbarOffset = _this$props.colorbarOffset,
        orientation = _this$props.orientation,
        others = (0, _objectWithoutPropertiesLoose2["default"])(_this$props, ["selectedColor", "disabled", "title", "className", "style", "buttonExtraOptions", "flyoutExtraOptions", "colorbarOffset", "orientation"]);
    var btnClassname = colorpickerClassName + "__button " + ('size' in buttonExtraOptions ? '' : 'size-default');
    return /*#__PURE__*/_react["default"].createElement("div", (0, _extends2["default"])({}, sanitize(others, ColorPicker), {
      className: colorpickerClassName + " " + className,
      ref: function ref(node) {
        _this2._colorPickerNode = node;
      },
      style: style
    }), /*#__PURE__*/_react["default"].createElement(_button["default"], (0, _extends2["default"])({
      "aria-controls": this._id + "-flyout",
      "data-tid": "ba-common-color-picker__button",
      hasIconOnly: true,
      kind: "ghost"
    }, sanitize(buttonExtraOptions, ColorPicker), {
      title: title,
      disabled: disabled,
      icon: _textColor_["default"].id,
      ref: this.buttonRef,
      onClick: this._handleOpen,
      className: btnClassname
    }), !disabled && /*#__PURE__*/_react["default"].createElement("span", {
      style: (0, _extends2["default"])({
        background: selectedColor
      }, colorbarOffset),
      className: colorpickerClassName + "__colorbar"
    })), open && /*#__PURE__*/_react["default"].createElement(_flyout.Flyout, (0, _extends2["default"])({
      id: this._id + "-flyout",
      "data-tid": "ba-common-color-picker__flyout"
    }, flyoutExtraOptions, {
      "aria-hidden": open,
      placement: orientation // eslint-disable-next-line no-underscore-dangle
      ,
      triggerNode: this.buttonRef.current._node,
      domNodeToAttachTo: this._colorPickerNode,
      hideArrow: true,
      offset: DEFAULT_OFFSET,
      onClose: this._handleOpen,
      className: colorpickerClassName + "__flyout"
    }), this.props.colors.map(this._displayColor)));
  };

  return ColorPicker;
}(_react.Component);

exports["default"] = ColorPicker;
(0, _defineProperty2["default"])(ColorPicker, "propTypes", {
  /** Colors to be selected */
  colors: _propTypes["default"].array,

  /** Function that will get called on click of a color */
  onColorSelected: _propTypes["default"].func,

  /** Selected color to show at the bottom of button */
  selectedColor: _propTypes["default"].string,

  /** Flag to disable the color picker */
  disabled: _propTypes["default"].bool,

  /** Tooltip when you hover on the color picker */
  title: _propTypes["default"].string,

  /** Flyout.propTypes.placement, default bottomRightStart/bottomLeftStart */
  orientation: _flyout.Flyout.propTypes.placement,

  /** Custom class name(s) */
  className: _propTypes["default"].string,

  /** Custom css styles */
  style: _propTypes["default"].object,

  /** Extra options for the button to pass to Flyout */
  buttonExtraOptions: _propTypes["default"].object,

  /** Extra options to pass to Flyout */
  flyoutExtraOptions: _propTypes["default"].object,

  /** ColorBar offset */
  colorbarOffset: _propTypes["default"].object
});
(0, _defineProperty2["default"])(ColorPicker, "defaultProps", {
  disabled: false,
  title: _StringResource["default"].get('title'),
  className: '',
  style: {},
  buttonExtraOptions: {},
  flyoutExtraOptions: {},
  colorbarOffset: {
    top: '12px',
    left: '1.25px'
  },
  orientation: _utils.Bidi.isMirroredUI() ? BOTTOM_RIGHT_START : BOTTOM_LEFT_START
});

/***/ }),

/***/ 188:
/***/ (function(module, exports) {

module.exports = require("@ba/ba-graphics/dist/icons-js/text-color_32");

/***/ }),

/***/ 189:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(190);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {"modules":true,"hmr":true}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(10)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {}

/***/ }),

/***/ 190:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(9)(undefined);
// imports


// module
exports.push([module.i, ".ba-common-colorpicker{position:relative}.ba-common-colorpicker__button.size-default{border:0px;padding:0px;min-height:0px}.ba-common-colorpicker__button svg{margin:0px !important}.ba-common-colorpicker__colorbar{color:#343334;width:14px;height:4px;position:absolute;-ms-high-contrast-adjust:none}.ba-common-colorpicker__colorbar:hover{cursor:pointer}.ba-common-colorpicker__flyout{padding:0.3em;width:166px;flex-wrap:wrap;display:flex;justify-content:flex-start;-ms-high-contrast-adjust:none}.ba-common-colorpicker__cell{display:inline-block;width:16px;height:16px;margin:2px 1.6px;border:1px solid}.ba-common-colorpicker__cell:hover{cursor:pointer}.ba-common-colorpicker__cell{border-color:#eaeaea}\n", ""]);

// exports
exports.locals = {
	"colorpickerClassName": "\"ba-common-colorpicker\""
};

/***/ }),

/***/ 191:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(0);

exports.__esModule = true;
exports["default"] = void 0;

var _utils = __webpack_require__(4);

var _ColorPickerResources = _interopRequireDefault(__webpack_require__(192));

/* IBM Confidential
*
* OCO Source Materials
*
* IBM Cognos Products: ba-ui-toolkit
* (C) Copyright IBM Corp. 2019
*
* The source code for this program is not published or otherwise
* divested of its trade secrets, irrespective of what has been
* deposited with the U.S. Copyright Office.
* NLS_ENCODING=UTF-8
* NLS_MESSAGEFORMAT_NONE
*/
// eslint-disable-line
var _default = new _utils.StringResource(_ColorPickerResources["default"]);

exports["default"] = _default;

/***/ }),

/***/ 192:
/***/ (function(module, exports) {

var amdi18n={"__root":{"title":"Selecting a color"},"__cs":{"title":"Výběr barvy"},"__da":{"title":"Vælg en farve"},"__de":{"title":"Farbe auswählen"},"__es":{"title":"Seleccionando un color"},"__fi":{"title":"Värin valinta"},"__fr":{"title":"Sélection d'une couleur"},"__hr":{"title":"Biranje boje"},"__hu":{"title":"Szín kiválasztása"},"__it":{"title":"Selezione di un colore"},"__ja":{"title":"カラーの選択"},"__kk":{"title":"Түсті таңдау"},"__ko":{"title":"색상 선택"},"__nb":{"title":"Velge en farge"},"__nl":{"title":"Een kleur selecteren"},"__no":{"title":"Velge en farge"},"__pl":{"title":"Wybieranie koloru"},"__pt":{"title":"Selecionando uma Cor"},"__pt-br":{"title":"Selecionando uma Cor"},"__ro":{"title":"Selectarea unei culori"},"__ru":{"title":"Выбор цвета"},"__sl":{"title":"Izbiranje barve"},"__sv":{"title":"Välj en färg"},"__th":{"title":"การเลือกสี"},"__tr":{"title":"Renk seçme"},"__zh":{"title":"选择颜色"},"__zh-cn":{"title":"选择颜色"},"__zh-hk":{"title":"選取顏色"},"__zh-mo":{"title":"選取顏色"},"__zh-sg":{"title":"选择颜色"},"__zh-tw":{"title":"選取顏色"}};amdi18n.init=function (language){
		// get the default language
		if(!language){
			if(window._i18n && window._i18n.locale){
				language = window._i18n.locale;
			}else if(document.documentElement.lang){
				language = document.documentElement.lang;
			}else{
				language = 'root';
			}
		}
		var target = this['__' + language] || this.__root;

		// copy definition to root level
		if (target) {
			for (var name in target) {
				this[name] = target[name];
			}
		}

		// fallback to root
		for(var name in this.__root){
			if(typeof this[name] === 'undefined'){
				this[name] = this.__root[name];
			}
		}
	};amdi18n.init();module.exports=amdi18n;

/***/ }),

/***/ 2:
/***/ (function(module, exports) {

module.exports = require("@babel/runtime/helpers/interopRequireWildcard");

/***/ }),

/***/ 28:
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE__28__;

/***/ }),

/***/ 3:
/***/ (function(module, exports) {

module.exports = require("prop-types");

/***/ }),

/***/ 4:
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE__4__;

/***/ }),

/***/ 5:
/***/ (function(module, exports) {

module.exports = require("@babel/runtime/helpers/inheritsLoose");

/***/ }),

/***/ 6:
/***/ (function(module, exports) {

module.exports = require("@babel/runtime/helpers/defineProperty");

/***/ }),

/***/ 7:
/***/ (function(module, exports) {

module.exports = require("@babel/runtime/helpers/extends");

/***/ }),

/***/ 8:
/***/ (function(module, exports) {

module.exports = require("@babel/runtime/helpers/objectWithoutPropertiesLoose");

/***/ }),

/***/ 9:
/***/ (function(module, exports) {

module.exports = require("css-loader/lib/css-base");

/***/ })

},[[185,0]]]);
});